<div class="form-builder-wrapper">
  <div class="form-builder" *ngIf="!isPreview">
    <div class="buttons">
      <button
        type="button"
        class="button is-small is-info"
        (click)="addInput()"
        translationEditableDirective="ADD_INPUT"
      >
        {{ 'ADD_INPUT' | translate }}
      </button>
      <button
        type="button"
        class="button is-small is-info"
        (click)="addSelect()"
        translationEditableDirective="ADD_SELECT"
      >
        {{ 'ADD_SELECT' | translate }}
      </button>
    </div>
    <app-form-builder-row
      [row]="row"
      [isPropertyType]="row.get('isPropertyType')"
      *ngFor="let row of rows; let index = index"
      [index]="index"
      (onAddInput)="addInput($event)"
      (onAddSelect)="addSelect($event)"
      (onAddOption)="addOption($event, row.get('isPropertyType'))"
      (onDeleteRow)="deleteRow($event)"
      (onDeleteOption)="deleteOption($event)"
      (onChangeField)="onChangeField($event)"
      (onChangeOptionsOrder)="onChangeOptionsOrder($event)"
      [isDuplicate]="isDuplicate"
    ></app-form-builder-row>
  </div>

  <form-preview
    [rows]="rows"
    [activeForm]="rows"
    *ngIf="isPreview"
  ></form-preview>

  <div class="buttons" *ngIf="rows.size">
    <button
      type="button"
      class="button is-small is-info"
      (click)="togglePreview()"
      translationEditableDirective="TOGGLE_PREVIEW"
    >
      {{ 'TOGGLE_PREVIEW' | translate }}
    </button>
  </div>
</div>
